import clickerSessions from './experiences/clicker-sessions.json';

const experienceTemplates = [
    {
        name: 'Clicker Sessions',
        description:
            'Clicker mode where guests start a session, clicks to take their photos and then scans a QR code to share them all.',
        definitionJsonString: JSON.stringify(clickerSessions),
    },
];

export { experienceTemplates };
